import React from "react";

export default function Title({ style, children }) {
  return (
    <div
      style={{
        fontFamily: "TradeGothicCondensed",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "12px",
        lineHeight: "19px",
        letterSpacing: "2px",
        textTransform: "uppercase",
        color: "#011F31",
        ...style
      }}
    >
      {children}
    </div>
  );
}
